// extracted by mini-css-extract-plugin
export default {"heading":"IconGrid_heading__OEi2B","linkContainer":"IconGrid_linkContainer__oc8sk","links":"IconGrid_links__o7tFd","link":"IconGrid_link__FbZts","number":"IconGrid_number__RDi9f"};